'use strict';

exports.__esModule = true;
exports.resolve = resolve;

var _Identifiers = require('../types/Identifiers');

var _ContextProps = require('../types/ContextProps');

var _Settings = require('../types/Settings');

var _TagTypes = require('../types/TagTypes');

var _sort = require('./sort');

var _merge = require('./merge');

var _buildOgImage2 = require('./build-og-image');

var _applyDefaultTags = require('../tags/defaults/apply-default-tags');

var _updateByIdentifier = require('../tags/values/update-by-identifier');

var _getByIdentifier = require('../tags/values/get-by-identifier');

function resolve(payload, context) {
  context = context || {};

  var result = (Array.isArray(payload) ? payload : []).reduce(function (acc, curr) {
    acc.tags = (0, _merge.merge)(acc.tags, curr && curr.tags);
    acc.settings = mergeSettings(acc.settings, curr && curr.settings);
    return acc;
  }, { tags: [], settings: {} });

  var robots = (0, _getByIdentifier.getValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS);
  if (robots === 'index') {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, '');
  } else if (!robots && !isIndexable(context)) {
    result.tags = (0, _updateByIdentifier.updateValueByIdentifier)(result.tags, _Identifiers.IDENTIFIERS.ROBOTS, 'noindex');
  }

  result.tags = (0, _applyDefaultTags.applyDefaultTags)(result.tags, context).concat(getLink(context, _ContextProps.CONTEXT_PROPS.NEXT, 'next')).concat(getLink(context, _ContextProps.CONTEXT_PROPS.PREV, 'prev'));

  var isTwitterEnabled = result.settings[_Settings.SETTINGS.TWITTER_ENABLED];
  if (!isTwitterEnabled) {
    result.tags = result.tags.filter(function (tag) {
      return !isTwitterTag(tag);
    });
  }

  result.tags = applyOgImageModifications(result.tags);
  result.tags = removeSchemaFromUrls(result.tags);
  result.tags = (0, _sort.sort)(result.tags);

  return result;
}

function mergeSettings(a, b) {
  a = a || {};
  b = b || {};
  Object.keys(b).forEach(function (key) {
    if (typeof b[key] !== 'undefined') {
      a[key] = b[key];
    }
  });
  return a;
}

function removeSchemaFromUrls(tags) {
  return [_Identifiers.IDENTIFIERS.OG_URL, _Identifiers.IDENTIFIERS.CANONICAL].reduce(function (acc, curr) {
    var value = (0, _getByIdentifier.getValueByIdentifier)(acc, curr);
    if (value) {
      return (0, _updateByIdentifier.updateValueByIdentifier)(acc, curr, removeSchema(value));
    }
    return acc;
  }, tags);
}

function removeSchema(url) {
  return url.replace(/^https?:/, '');
}

function applyOgImageModifications(tags) {
  var OG_IMAGE = _Identifiers.IDENTIFIERS.OG_IMAGE,
      OG_IMAGE_WIDTH = _Identifiers.IDENTIFIERS.OG_IMAGE_WIDTH,
      OG_IMAGE_HEIGHT = _Identifiers.IDENTIFIERS.OG_IMAGE_HEIGHT;

  var _buildOgImage = (0, _buildOgImage2.buildOgImage)(tags),
      src = _buildOgImage.src,
      width = _buildOgImage.width,
      height = _buildOgImage.height;

  return [[OG_IMAGE, src], [OG_IMAGE_WIDTH, width], [OG_IMAGE_HEIGHT, height]].reduce(function (acc, curr) {
    var identifier = curr[0],
        value = curr[1];

    return value ? (0, _updateByIdentifier.updateValueByIdentifier)(acc, identifier, value) : acc;
  }, tags);
}

function getLink(context, name, rel) {
  if (context[name]) {
    return [{
      type: _TagTypes.TAG_TYPES.LINK,
      props: {
        rel: rel,
        href: context[name]
      }
    }];
  }
  return [];
}

function isIndexable(context) {
  return context[_ContextProps.CONTEXT_PROPS.INDEX_SITE] && context[_ContextProps.CONTEXT_PROPS.INDEX_PAGE];
}

function isTwitterTag(tag) {
  var type = (tag || {}).type;
  var name = ((tag || {}).props || {}).name;
  return type === _TagTypes.TAG_TYPES.META && typeof name === 'string' && name.startsWith('twitter:');
}